import { Spinner } from "@/components/General/Spinner/spinner.component";

import { useDefaultHook } from "../helpers/useDefault.hook";
import { DefaultAddressPartial } from "../partials/defaultAddress";

const DefaultBusinessAddress = () => {
    const { loading } = useDefaultHook();

    if (loading) {
        return <Spinner />;
    }

    return <DefaultAddressPartial />;
};

export { DefaultBusinessAddress };
